import { PJAxios, sendLogin, usePJStore, useUserInfo } from '@jaf/jaf-react-core';
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';

function NuovaRichiesta(props) {


    const [visibleItems, setVisibleItems] = useState([]);
   
    const getText = usePJStore((state) => state.i18n_getText)

    const [links, setLinks] = useState([]);
    const [albero, setAlbero] = useState(null);
    const [loading, setLoading] = useState(false);
    const [groups, setGroups] = useState(null);

    const { storage } = usePJStore((state) => state.storage)

    const isLogged = useUserInfo() != null;
    

    const caricaConfigurazioni = (id_config) => {
        PJAxios().post('/chatbot/modificaConfigurazioni', { idConfig: id_config }).then((res) => {
            //toast.current.show({ severity: 'info', detail: getText("BOT_WELCOME"),life: 5000  });
            setAlbero(configureTree(res.data.strutturaAlbero.albero))
            setLoading(false);
        })
    }

    const isAllowed = (vis) => {

        if (vis == null || vis == undefined) {
            return true
        }

        groups.forEach((group) => {
            if (vis.includes(group)) {
                return true;
            }
        })

        return false;
    }

    const configureTree = (tree, rootId) => {

        let nodes = [];

        let radice = {
            key: tree.radice.elemento_id,
            //label: getText(tree.radice.albero_dn),
            label: tree.radice.albero_dn,
            icon: "pi pi-sitemap",
            data: tree.radice,
            children: [],
            root: true
        }

        tree.listaCompletaRami.forEach((ramoItem) => {

            if (isAllowed(ramoItem.elemento.extra_fields.filtro_vis)) {
                //var label = getText(ramoItem.elemento.extra_fields.bundle != null ? ramoItem.elemento.extra_fields.bundle : ramoItem.elemento.extra_fields.titolo);
                var label = ramoItem.elemento.extra_fields.bundle != null ? ramoItem.elemento.extra_fields.bundle : ramoItem.elemento.extra_fields.titolo;
                if (label.length > 100) {
                    label = label.slice(0, 100) + "...";
                }


                var ramo = {
                    key: ramoItem.elemento_id,
                    label: label,
                    data: ramoItem,
                    children: []
                }

                tree.listaCompletaFoglie.forEach((fogliaItem) => {


                    var labelSuffix = "";
                    if (fogliaItem.elemento.extra_fields.open_dt != null && fogliaItem.elemento.extra_fields.close_dt != null) {
                        labelSuffix = " (" + moment(fogliaItem.elemento.extra_fields.open_dt).format("DD-MM-YYYY") + " a " + moment(fogliaItem.elemento.extra_fields.close_dt).format("DD-MM-YYYY") + ")";
                    }


                    //var labelF = getText(fogliaItem.elemento.extra_fields.titolo);
                    var labelF = fogliaItem.elemento.extra_fields.titolo;
                    if (labelF.length > 100) {
                        labelF = labelF.slice(0, 100) + "...";
                    }


                    var foglia = {
                        key: fogliaItem.elemento_id,
                        label: labelF + labelSuffix,
                        data: fogliaItem,
                        children: []
                    }

                    if (fogliaItem.elemento_padre_id === ramoItem.elemento_id) {
                        ramo.children.push(foglia);
                    }
                })

                if (ramoItem.elemento_padre_id === radice.data.elemento_id) {
                    ramo.id_item_parent = tree.radice.extra_fields.id_item
                    radice.children.push(ramo);
                } else {
                    radice.children.forEach((radiceChilds) => {
                        if (ramoItem.elemento_padre_id === radiceChilds.key) {
                            try {
                                ramo.id_item_parent = radiceChilds.elemento.extra_fields.id_item
                                radiceChilds.children.push(ramo);
                            } catch (exception) {
                                 //console.log(radiceChilds.elemento);
                            }

                        }
                    })
                }
            }


        })

        nodes.push(radice);
        return nodes;
    }


    useEffect(() => {

         if (!isLogged) {
            sendLogin();
        } else {
            PJAxios().get('/nuovaRichiesta/getVisibleItems/64').then((res) => {

                setGroups(res.data.groups)

                caricaConfigurazioni(64)
                setLinks(res.data)
            })
        }
    }, []);

    const openLink = (link) => {
        let url = process.env.REACT_APP_CREATE_TICKET_JUMP_URL;
        url = url.replace("::selectedNodeId::", link.id_node)
        window.open(url, '_blank', 'noreferrer')
    }

    return (

        <>
            {links.map((link) =>
                <div>
                    <Button label={getText(link.b_name)} onClick={() => openLink(link)} />
                </div>

            )}
        </>

    )
}

export default NuovaRichiesta
